<template>
  <el-row v-loading="isLoading">
    <el-table
      :data="jobs"
      stripe
      class="w-100"
    >
      <el-table-column
        label="Name"
        :formatter="row => $_.get(row, 'job', '-') || '-'"
      />
      <el-table-column
        label="Status"
        :formatter="row => $_.get(row, 'status', '-') || '-'"
      />
      <el-table-column
        label="Next Run"
        :formatter="row => formatTime($_.get(row, 'scheduled_in', undefined)) || '-'"
      />
      <el-table-column
        label="Actions"
        align="right"
      >
        <template v-slot="{ row }">
          <el-button @click.native="start(row.job)">
            Run Now
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-row>
</template>
<script>
import Request, { GET, POST } from '@/plugins/sdk/Request'

export default {
  data () {
    return {
      title: 'Legacy Workers',
      breadcrumb:
      {
        name: 'Workers',
        route: { name: 'configuration-legacy-workers' }
      },
      actions: [
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => this.load()
        }
      ],
      jobs: [],
      isLoading: false
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.isLoading = true

      const request = await (Object.assign(new Request(), {
        method: GET,
        _pathname: 'legacy/workers'
      })).build()

      const response = await fetch(request)

      if (response.ok) {
        this.jobs = await response.json()
        const tenancyId = (await this.$session.instance).tenancy.id
        const tenancy = (tenancyId === '353dc048-af1e-44c9-abef-13cc2c92fda8' ? 'tigfre' : 'opn360')
        this.jobs = this.jobs.filter((job) => job.job.includes(tenancy))
      }

      this.isLoading = false
    },
    async start (id) {
      const request = await (Object.assign(new Request(), {
        method: POST,
        _pathname: 'legacy/workers/' + id
      })).build()

      const response = await fetch(request)

      if (response.ok) {
        this.$message({ message: 'Successfully started', type: 'success' })
      }
    },
    formatTime (value) {
      if (value === undefined) {
        return null
      }
      return this.$moment.utc(1000 * value).format('H[h] mm[m] ss[s]')
    }
  }
}
</script>
